(function($, Drupal) {
  Drupal.behaviors.navigation = {
    attach: function(context, settings) {

      // should start at 0
      if ($(window).width() > 992) {
        let $position = $(window).scrollTop();
        $(window).scroll(function() {
          let scroll = $(window).scrollTop();
          if (scroll > $position && !$('.navbar-fixed-top').hasClass('tucked') && $(window).scrollTop() > 100) {
            $('.navbar-fixed-top').addClass('tucked');
          }
          else if (scroll < $position && $('.navbar-fixed-top').hasClass('tucked')) {
            $('.navbar-fixed-top').removeClass('tucked');
          }
          $position = scroll;
        });
      }
    }
  };
})(jQuery, Drupal);
